import api from './authService';
import { UserNote, CreateUserNoteRequest, UserNoteAcknowledgment } from '../types/userNote';

export const userNoteService = {
  /**
   * Get unread notes count for a specific user
   */
  async getUnreadNotesCount(userId: string): Promise<number> {
    const response = await api.get(`/usernotes/user/${userId}/unread-count`);
    return response.data;
  },

  /**
   * Get all notes for a specific user
   */
  async getUserNotes(userId: string): Promise<UserNote[]> {
    const response = await api.get(`/usernotes/user/${userId}`);
    return response.data;
  },

  /**
   * Create a new note for a user
   */
  async createUserNote(userId: string, data: CreateUserNoteRequest): Promise<UserNote> {
    const response = await api.post(`/usernotes/user/${userId}`, data);
    return response.data;
  },

  /**
   * Delete a note (admin only)
   */
  async deleteUserNote(noteId: string): Promise<void> {
    await api.delete(`/usernotes/${noteId}`);
  },

  /**
   * Acknowledge a note
   */
  async acknowledgeUserNote(noteId: string): Promise<UserNoteAcknowledgment> {
    const response = await api.post(`/usernotes/${noteId}/acknowledge`);
    return response.data;
  },

  /**
   * Remove acknowledgment from a note
   */
  async removeAcknowledgment(noteId: string): Promise<void> {
    await api.delete(`/usernotes/${noteId}/acknowledge`);
  },
};

export default userNoteService;
